import requestProvider from "./axiosHandler";

const unAssignPermission = ({permissionId, roleId}) => {

    return requestProvider
        .delete(`/role-permission/unassign`, {
            data: {
                permissionId: permissionId,
                roleId: roleId
            }
        })
}

const assignAllpermissions = (roleId) => {

    return requestProvider
        .post('/role-permission/assign-all', {
            roleId:roleId
        })
}

const assignPermission = ({permissionId, roleId}) => {

    return requestProvider
        .post('/role-permission/assign', {
            permissionId: permissionId,
            roleId: roleId
        })
}

const getAllPermissions = async() => {

    return requestProvider
        .get('/permission/get-all')
}
const sortRolesControllers = (list) => {
    let baseController = null
    let permissions = {}

    list.map((item) => {
        let controllerName = item.controllerAlias
        if (!baseController || baseController !== controllerName) {
            baseController = controllerName
        }
        if (!permissions[baseController]) {
            permissions[baseController] = []
        }

        permissions[baseController].push(item)
    })
    return permissions
}

const getHasPermissions = (id) => {

    return requestProvider
        .get(`/permission/get-with-has-permission/${id}`)
        .then(data => sortRolesControllers(data.data))
}

const unAssignAllPermissions = (id) => {

    return requestProvider
        .delete(`/role-permission/unassign-all`,{
            data: {
                roleId: id
            }
        })
}

export {getAllPermissions, assignPermission, assignAllpermissions, unAssignPermission, getHasPermissions, unAssignAllPermissions}
